import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const ExitIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M11.95 22.364a1 1 0 0 0 1.414-1.415L9.414 17H22a1 1 0 1 0 0-2H9.414l3.95-3.95a1 1 0 0 0-1.414-1.414l-5.304 5.303a1.5 1.5 0 0 0 0 2.121l5.304 5.304ZM26 6a1 1 0 0 1 2 0v20a1 1 0 1 1-2 0V6Z" />
  </BaseIcon>
);
